"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const user_info_1 = __importDefault(require("../user-info/user-info"));
const license_info_1 = __importDefault(require("../license-info/license-info"));
const profile_1 = require("../../../../shared/components/profile");
const contact_info_1 = __importDefault(require("../contact-info/contact-info"));
const DelIcon_1 = __importDefault(require("../../../../svgIcons/DelIcon"));
require("./edit.scss");
const profileSlice_1 = require("../../../../redux/slices/profileSlice");
const userSlice_1 = require("../../../../redux/slices/userSlice");
const common_1 = require("../../../../utils/common");
const successfullyDeleted_1 = __importDefault(require("../../../../shared/components/profile/modals/successfullyDeleted/successfullyDeleted"));
const fillAllError = `* Please fill in all required fields.`;
let submitted = false;
let afterAction = false;
class ProfileEdit extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            files: [],
            successfullyModal: false
        };
        this.deleteUserModal = (e) => {
            this.props.toggleDeleteAccount();
        };
        this.deleteAccountModal = () => {
            setTimeout(() => {
                this.setState({ successfullyModal: !this.state.successfullyModal });
            }, 1000);
            this.props.deleteAccount();
        };
        this.handleFileData = async (data, id, deleted) => {
            if (deleted) {
                this.setState({
                    files: [...this.state.files.filter(f => f.id !== id)]
                });
            }
            else {
                this.setState({
                    files: [...this.state.files, ...data]
                });
            }
            this.props.setFormUpdate();
        };
        this.save = async (e) => {
            afterAction = true;
            const { user, profile, profile: { licenseForm, userForm, firstFlow } } = this.props;
            if (!userForm.valid || (!licenseForm.valid && licenseForm.changed)) {
                await this.validateAllForms();
                return common_1.scrollToElemError({ firstFlow });
            }
            else {
                if (submitted)
                    return;
                submitted = true;
                this.props.saveProfile(profile, user.id, this.state.files);
            }
        };
        this.neverMind = (e) => {
            const { user, profile: { userForm, licenseForm, addLicense, profileSaveSuccess, firstFlow } } = this.props;
            if (firstFlow && (!userForm.valid || (!licenseForm.valid && licenseForm.changed))) {
                return common_1.scrollToElemError();
            }
            if (firstFlow) {
                this.props.setFirstFlow({ firstFlow: false });
                this.closeFirstFlowModal();
            }
            if (addLicense) {
                this.props.toggleProfileLicense();
            }
            if (profileSaveSuccess) {
                this.props.saveSuccess();
            }
            this.props.toggleProfileEdit({ payload: user });
        };
        this.closeFirstFlowModal = () => {
            common_1.closeModal('first-flow-modal');
            return window.location.href = '#/home';
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { profile: { profileSaveSuccess, editProfile, generalError, userForm, licenseForm, firstFlow, updated } } = this.props;
        if (profileSaveSuccess && editProfile) {
            this.neverMind(null);
        }
        if (profileSaveSuccess && firstFlow) {
            // this.closeFirstFlowModal();
        }
        if (generalError || !userForm.valid || !licenseForm.valid) {
            submitted = false;
        }
        if (userForm.changed || licenseForm.changed || updated) {
            localStorage.setItem('profile_changed', 'profile_changed');
        }
        else {
            localStorage.removeItem('profile_changed');
        }
    }
    componentWillUnmount() {
        this.props.resetState();
        submitted = false;
        localStorage.removeItem('profile_changed');
    }
    async validateAllForms() {
        const { profile: { addLicense, userForm, licenseForm, } } = this.props;
        const lForm = { form: licenseForm, key: 'userLicenseFormChange' };
        const forms = [
            { form: userForm, key: 'userFormChange' }
        ];
        if (addLicense) {
            forms.push(lForm);
        }
        for (const single of forms) {
            for (const prop in single.form.data) {
                const value = single.form.data[prop].value;
                const err = single.form.data[prop].error;
                const dirty = single.form.data[prop].dirty;
                if (typeof this.props[single.key] === 'function' && !err) {
                    await this.props[single.key]({ value, field: prop, validate: true });
                }
            }
        }
    }
    render() {
        const { user, profile: { userForm, licenseForm, deleteAccountModal, generalError, firstFlow }, deleteAccount, className } = this.props;
        const { successfullyModal } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { id: 'edit attorney-profile-container', className: className },
                react_1.default.createElement("div", { className: "profile-content" },
                    firstFlow && react_1.default.createElement("div", { className: "tab-titles" }, "Profile"),
                    react_1.default.createElement(core_1.Grid, { container: true, wrap: "wrap", className: "d-flex justify-content-between" },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 4, className: "user-info-grid d-flex" },
                            react_1.default.createElement(user_info_1.default, { edit: true })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 8, className: "case-info" },
                            user.roleId !== 9 && react_1.default.createElement(license_info_1.default, null),
                            react_1.default.createElement(contact_info_1.default, { edit: true, handleFileData: (data, id, del) => this.handleFileData(data, id, del) }),
                            react_1.default.createElement("div", { className: 'w-100 profile-action-box' },
                                react_1.default.createElement("div", { className: "w-100 del-modal" },
                                    react_1.default.createElement(core_1.Button, { disableRipple: true, onClick: this.deleteUserModal, "data-qa": 'delete-account-btn', startIcon: react_1.default.createElement(DelIcon_1.default, null), className: "v2-btn-icon-link mt-10" }, "Delete My Account")),
                                react_1.default.createElement("div", { className: "w-100 save-never-mind" },
                                    react_1.default.createElement(core_1.Button, { onClick: this.save, onDoubleClick: (e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }, "data-qa": 'save-btn', variant: "contained", color: "primary", disableRipple: true, className: `v2-btn v2-btn-primary ${firstFlow ? ' mr-0' : ''}` }, "Save"),
                                    !firstFlow && react_1.default.createElement(core_1.Button, { onClick: this.neverMind, "data-qa": 'never-mind-btn', onDoubleClick: (e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }, disableRipple: true, variant: "contained", className: " v2-btn v2-btn-tertiary" }, "Never Mind"),
                                    ((((!userForm.valid && userForm.changed) || (!licenseForm.valid && licenseForm.changed)) && afterAction) || generalError) &&
                                        react_1.default.createElement(core_1.FormHelperText, { error: true, className: "helper-text-error" }, generalError || fillAllError))))))),
            deleteAccountModal && react_1.default.createElement(profile_1.DeleteAccount, { open: deleteAccountModal, cancelable: {
                    buttonTitle: 'Never Mind',
                    action: this.deleteUserModal
                }, submit: {
                    buttonTitle: 'Delete',
                    action: this.deleteAccountModal
                } }),
            !generalError && successfullyModal && react_1.default.createElement(successfullyDeleted_1.default, { open: successfullyModal, title: 'Deleted', description: 'Your profile was successfully deleted.', cancelable: this.deleteAccountModal, submit: {
                    buttonTitle: 'Delete',
                    action: deleteAccount,
                } })));
    }
}
const mapStateToProps = (state) => {
    const { user, profile } = state;
    return {
        user,
        profile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleProfileEdit: (data) => dispatch(profileSlice_1.toggleProfileEdit(data)),
        toggleProfileLicense: () => dispatch(profileSlice_1.toggleProfileLicense()),
        saveProfile: (data, id, files) => dispatch(profileSlice_1.saveProfile(data, id, files)),
        userFormChange: (data) => dispatch(profileSlice_1.userFormChange(data)),
        userLicenseFormChange: (data) => dispatch(profileSlice_1.userLicenseFormChange(data)),
        toggleDeleteAccount: () => dispatch(profileSlice_1.toggleDeleteAccount()),
        deleteAccount: () => dispatch(userSlice_1.deleteAccount()),
        saveSuccess: () => dispatch(profileSlice_1.saveSuccess()),
        resetState: () => dispatch(profileSlice_1.resetState()),
        setFormUpdate: () => dispatch(profileSlice_1.setFormUpdate()),
        setFirstFlow: (data) => dispatch(profileSlice_1.setFirstFlow(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);
